import React,{useEffect, useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import Alerta from "../components/Alerta";

import Swal from 'sweetalert2'
import useAuth from "../hooks/useAuth";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

 
const emailRegexp = new RegExp(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z]{2,4})+$/);

const OlvidePassword = () => {

  const [email,setEmail]= useState('');
  const [alerta, setAlerta] = useState({});
  const {listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});
  const navigate = useNavigate();

  const handleSubmit = async (e) =>{
    e.preventDefault();

    if (!emailRegexp.test(email)) {
      setAlerta({
        msg:`${lbl_validacion_msj_complete_campo}.`,
        error:true
      })
      return;
    }
    setAlerta({});

    try {

     
      
      Swal.fire({
        title:`¡${lbl_validacion_msj_indicaciones}!`,
        text: email,
        icon:'success',
        confirmButtonText:`${sumilla_aceptar}`,
        confirmButtonColor: '#B80A28',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/auth/validateCode/12312")
        }
      });

      setEmail('');
    } catch (error) {
      
    }
    
  }
  
  const {msg} = alerta;

  useEffect(() => {
  
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        olvidaste_contrasena: obtenerLabelEtiqueta(
          "lbl_olvidaste_contrasena",
          listadoEtiquetas
        ),
        ingresa_correo: obtenerLabelEtiqueta(
          "lbl_global_msj_ingresa_correo",
          listadoEtiquetas
        ),
        olvidaste_email: obtenerLabelEtiqueta(
          "lbl_olvidaste_email",
          listadoEtiquetas
        ),
        enviar: obtenerLabelEtiqueta(
          "lbl_olvidaste_enviar",
          listadoEtiquetas
        ),
        volver_inicio: obtenerLabelEtiqueta(
          "lbl_global_msj_volver_inicio",
          listadoEtiquetas
        ),
        sumilla_aceptar: obtenerLabelEtiqueta(
          "lbl_sumilla_aceptar",
          listadoEtiquetas
        ),
        lbl_validacion_msj_indicaciones: obtenerLabelEtiqueta(
          "lbl_validacion_msj_indicaciones",
          listadoEtiquetas
        ),
        lbl_validacion_msj_complete_campo:obtenerLabelEtiqueta(
          "lbl_validacion_msj_complete_campo",
          listadoEtiquetas
        ),
        
      });
    }
  }, [listadoEtiquetas]);

  const { olvidaste_contrasena,ingresa_correo,olvidaste_email,enviar,volver_inicio,sumilla_aceptar,lbl_validacion_msj_indicaciones,lbl_validacion_msj_complete_campo } = etiquetas;

  return (
    <div className="login-content va-middle">
      <div className="center">
        <div className="log-title">
          <h1>{olvidaste_contrasena}</h1>
          <div className="separator"></div>
        </div>
        <div className="description text-center ">
          <p>
            {ingresa_correo}.
          </p>
        </div>

        { msg && <Alerta alerta={alerta} />}
        <form onSubmit={(e)=>{handleSubmit(e)}}>
          <div className="mb-4">
            <label htmlFor="exampleFormControlInput1" className="visually-hidden">
              Email address
            </label>
            <div className="input-group flex-nowrap">
              <input
                autoComplete="off"
                type="email"
                className="form-control login-control form-control-sm text-uppercase"
                id="exampleFormControlInput1"
                placeholder={olvidaste_email} 
                value={email}
                onChange={(e)=>{setEmail(e.target.value)}}
                
                />
                <span
                  className="input-group-text login-control "
                  id="addon-wrapping">
                  <i className="far fa-envelope"
                    style={{color: "#5F5F5F"}}></i>
                </span>
             
            </div>
          </div>

          <div className="text-center mt-5">
            <button type="submit" className="btn btn-send mb-3">
              {enviar}
            </button>
            <Link  className="mt-4 d-block" to='/auth'>
              {volver_inicio}
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OlvidePassword;
